@switch (dialog()) {
  @case ('classic') {
    <ai-iqboost-classic
      #dialogView
      (actionCompleted)="actionCompleted.emit($event)"
    ></ai-iqboost-classic>
  }
  @case ('singleHousehold') {
    <ai-iqboost-single-household
      #dialogView
      (actionCompleted)="actionCompleted.emit($event)"
    ></ai-iqboost-single-household>
  }
  @case ('allHouseholds') {
    <ai-iqboost-all-households
      #dialogView
      (actionCompleted)="actionCompleted.emit($event)"
    ></ai-iqboost-all-households>
  }
}
